export const FILES_PAGINATED = 'FILES_PAGINATED';
export const CRON_HISTORY_PAGINATED = 'CRON_HISTORY_PAGINATED';
export const QUARANTINE_FILES_PAGINATED = 'QUARANTINE_FILES_PAGINATED';
export const QUARANTINE_SAMPLES_PAGINATED = 'QUARANTINE_SAMPLES_PAGINATED';
export const RESOURCE_NOTIFICATIONS_PAGINATED = 'RESOURCE_NOTIFICATIONS_PAGINATED';
